export default {
  install(Vue) {
    const longPooling = async function(
      connection,
      delay = 1,
      since = new Date().toISOString(),
      isNew = false,
      controller = undefined
    ) {
      if (!controller) {
        controller = new AbortController();
      }
      this.$io.controller = controller;
      const signal = controller.signal;
      isNew && this.$emit("connect");
      let ts = -1;
      const throttler = new Promise((resolve) => {
        ts = setTimeout(() => resolve(++delay), 5000 * delay);
      });
      try {
        const responses = await (
          await fetch(`${connection}&since=${since}`, {
            credentials: "include",
            signal,
          })
        ).json();
        if (responses.length) {
          since = responses[responses.length - 1][1].createdAt;
          responses.forEach((response, i) => {
            /**
             * each response is an array => [eventName, data]
             */
            if (
              typeof response === "object" &&
              response.length === 2 &&
              typeof response[0] === "string"
            ) {
              return setTimeout(
                () => this.$emit(response[0], response[1]),
                i * 500
              );
            }
            throw `Pooling response does not have ${!(
              response[0] || response[1]
            ) ||
              "event and data" ||
              (response[1] && "data") ||
              "event"} attributes`;
          });
        }
        this.longPooling(connection, 1, since, false, controller);
        clearTimeout(ts);
      } catch (e) {
        // eslint-disable-next-line
        console.warn(e);
        if (e.name === "AbortError") {
          // eslint-disable-next-line
          console.warn(`Pooling request disconnected`);
          return this.$emit("disconnect");
        }
        throttler.then((delayed) => {
          if (delayed >= 2) {
            // eslint-disable-next-line
            console.warn(`Pooling request disconnected`);
            return this.$emit("disconnect");
          }
          // eslint-disable-next-line
          console.warn(
            `Pooling request recountred errors, retrying in ${5000 *
              delayed} seconds`
          );
          this.longPooling(connection, delayed, since, false, controller);
        });
      }
      return controller;
    };

    const fakeSocket = {
      async request(method, url, data, cb) {
        try {
          const options = {
            method,
            mode: "cors",
            cache: "no-cache",
            credentials: "include",
            redirect: "follow",
            referrerPolicy: "no-referrer",
            body: data
          };
          const response = await fetch(url, options);
          if (!response.ok) {
            throw response.statusText;
          }
          const body = await response.json();
          cb(body, response);
        } catch (error) {
          cb(null, { error });
        }
      },
      async get(url, data, cb) {
        const urlObject = new URL(url);
        const qs = new URLSearchParams(urlObject.search);
        for (let key in data) {
          qs.set(key, data[key]);
        }
        urlObject.search = qs.toString();
        url = urlObject.toString();
        return this.request("GET", url, undefined, cb);
      },
      async post(url, data, cb) {
        let body;
        if (data.type === "file") {
          body = new FormData();
          body.append("type", data.type);
          body.append("data", JSON.stringify(data.data));
          body.append("file", data.data.file);
        } else {
          body = JSON.stringify(data);
        }
        return this.request("POST", url, body, cb);
      },
    };

    Vue.prototype.longPooling = longPooling;

    Vue.prototype.$io = {
      socket: fakeSocket,
      controller: null,
      disconnect() {
        this.controller && this.controller.abort();
      },
    };

    let addListeners = function() {
      if (this.$options["socket"]) {
        let conf = this.$options.socket;
        if (conf.events) {
          let prefix = conf.prefix || "";
          Object.keys(conf.events).forEach((key) => {
            let func = conf.events[key].bind(this);
            this.$on(prefix + key, func);
            conf.events[key].__binded = func;
          });
        }
        // this.longPooling.bind(this)(connection, 1)
      }
    };

    let removeListeners = function() {
      if (this.$options["socket"]) {
        let conf = this.$options.socket;
        if (conf.events) {
          let prefix = conf.prefix || "";
          Object.keys(conf.events).forEach((key) => {
            this.$off(prefix + key, conf.events[key].__binded);
          });
        }
      }
    };
    Vue.mixin({
      beforeCreate: addListeners,
      beforeDestroy: removeListeners,
    });
  },
};
